// 네이버쪽 추적 코드
export const NAVER_WCS_ACCOUNT_ID = 's_142b2644a510';
